import cartEvents from '../../checkout/cart/events';



const events = {
    _orderControlInteractionLabel: function (category, label) {
        this._gaEvent(category, window.location.href, label);
    },
    _gaEvent: function (category, action, label) {
        if (/\.com/gi.test(action)) {
            action = action.split('?')[0];
        }
        this._triggerEvent({
            event: 'gaTriggerEvent',
            gaEventCategory: category,
            gaEventAction: action,
            gaEventLabel: label
        });
    },
    ...cartEvents
};

export default events;
